import DataHeaderType from "../Types/DataHeaderType";

class HeaderStore {
  private menu?: DataHeaderType[]

  getMenu() {
    return this.menu
  }

  setMenu(menu: DataHeaderType[]) {
    this.menu = menu
  }

  getProgramsMenu() {
    return this.menu ? this.menu[0].children ?? [] : []
  }
}

export default new HeaderStore()
